import GenerateSchemaForm from '@hooks/generateSchemaForm';
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { updateActionItem } from '@reduxLocal/actions/actions';
import { store } from '@reduxLocal/persistState';

const actionOptionStyles = StyleSheet.create({
  container: {
    backgroundColor: "white", borderRadius: 10, paddingRight: 5, flex: 1,
    minHeight: 200,
  },
})
const flowList = [{
  key: 'email',
  icon: 'mail-bulk',
  title: 'Email',
  component: ({ index, initialVals }) => {
    const formatInitialVals = () => {
      if (initialVals.stage_action) {
        return { ...initialVals, stage_action: initialVals.stage_action.title }
      }
      return initialVals;

    }

    return (<View style={[actionOptionStyles.container, { paddingTop: 30 }]}>
      <GenerateSchemaForm buttonLabel='Save' customStyling={{ minHeight: 400, paddingRight: 20 }} initialData={formatInitialVals()} schema={{
        'stage_action': { type: 'template_select', ref: 'template_select' },
        'headline': {
          title: "headline",
          type: "string",
        },
        'when': {
          type: 'dropDown',
          content: { enum: ['immediately', 'after', 'before', 'on'] }
        },
      }}
        submitFunction={(vals) => {
          let newVals;
          if (Object.keys(vals).includes('stage_action')) {
            //Extract _id from stage_action and replace it with the value
            newVals = { ...vals, stage_action: vals.stage_action._id }
          }
          //Function that dispatches to redux
          store.dispatch(updateActionItem(newVals, index));
        }}
      />
    </View>)
  }
}, {
  key: 'project',
  icon: 'project-diagram',
  title: 'Project'
}, {
  key: 'calendar',
  icon: 'calendar',
  title: 'Calendar'
}, {
  key: 'document',
  icon: 'file-contract',
  title: 'Document'
}, {
  key: 'integration',
  icon: 'link',
  title: 'Integration'
},
{
  key: 'call',
  icon: 'phone',
  title: 'Call'
},
  // {
  //   key: 'notify',
  //   icon: 'bell',
  //   title: 'Notify Team',
  //   component: ({ index, initialVals }) => (<View style={actionOptionStyles.container}>
  //   </View>)
  // }
];


export default flowList;